<template>
    <div class="blog-carousel">
        <div class="swiper blog-carousel__swiper anim" ref="carousel">
            <div class="swiper-wrapper">
                <slot/>
            </div>
        </div>
    </div>
</template>

<script setup>
import Swiper from 'swiper'
import { EffectCoverflow } from 'swiper/modules'
import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue'

const carousel = ref(null)
let swiperInstance = null

const getConfig = () => ({
    modules: [EffectCoverflow],
    effect: 'coverflow',
    centeredSlides: true,
    slidesPerView: 2.5,
    initialSlide: 1,
    threshold: 8,
    touchAngle: 35,
    touchStartPreventDefault: false,
    touchMoveStopPropagation: false,
    touchReleaseOnEdges: true,
    passiveListeners: true,
    preventClicks: true,
    preventClicksPropagation: false,
    observer: false,
    observeParents: false,
    resizeObserver: true,
    coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 160,
        modifier: 1.15,
        slideShadows: false,
    },
})

onMounted(async () => {
    await nextTick()

    if (!carousel.value) return

    swiperInstance = new Swiper(carousel.value, getConfig())
})

onBeforeUnmount(() => {
    swiperInstance?.destroy(true, true)
    swiperInstance = null
})
</script>
